import { useState } from 'react';
import {
  Container, Paper, Typography, TextField, Button, Box, Alert, Link, Stack,
  InputAdornment, IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import { signupClinic } from '../api/saasApi';
import logo from '../assets/logo.png';

const Signup = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ clinicName: '', adminName: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await signupClinic(form);
      if (res.data?.succeeded === false) { setError(res.data.messages?.[0] || 'Signup failed'); return; }
      // Email verification required — send to OTP screen.
      // OtpVerify reads the address from ?i= (base64), not router state.
      navigate(`/otp-verify?i=${btoa(form.email)}`);
    } catch (err) {
      setError(err?.response?.data?.messages?.[0] || 'Signup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Box textAlign="center" mb={3}>
        <img src={logo} alt="Vqure" style={{ height: 48 }} />
      </Box>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>Create your clinic</Typography>
        <Typography color="text.secondary" mb={2}>Start a free 14-day trial. No card required.</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={submit}>
          <Stack spacing={2}>
            <TextField label="Clinic name" required value={form.clinicName} onChange={set('clinicName')} fullWidth />
            <TextField label="Your name" required value={form.adminName} onChange={set('adminName')} fullWidth />
            <TextField label="Email" type="email" required value={form.email} onChange={set('email')} fullWidth />
            <TextField
              label="Password"
              type={showPwd ? 'text' : 'password'}
              required
              value={form.password}
              onChange={set('password')}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPwd((s) => !s)}
                      edge="end"
                      size="small"
                      aria-label={showPwd ? 'Hide password' : 'Show password'}
                    >
                      {showPwd ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button type="submit" variant="contained" size="large" disabled={loading}>
              {loading ? 'Creating…' : 'Create clinic'}
            </Button>
          </Stack>
        </Box>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Already have an account? <Link href="/" underline="hover">Sign in</Link>
        </Typography>
      </Paper>
    </Container>
  );
};

export default Signup;
